import type { FC } from 'react'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronRightIcon } from '@segment/matcha/components/Icons/Common'

import CardBase, * as Card from '@segment/matcha/recipes/Card'

import type { Lesson } from '@segment/api/routes/academy/types'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

import LessonLabel from './LessonLabel'

export interface LessonCardProps {
  lesson: Lesson
  actionText?: string
}

const LessonCard: FC<LessonCardProps> = ({ lesson, actionText = `Start this lesson` }) => {
  const pageConfig = usePageConfig()
  const { courseNumber, lessonNumber, title, description, url } = lesson

  return (
    <CardBase href={getAbsoluteUrl(url, pageConfig)}>
      <Card.Body>
        <Card.Copy>
          <LessonLabel courseNumber={courseNumber} lessonNumber={lessonNumber} />
          <Card.Headline>{title}</Card.Headline>
          <Card.Description>{description}</Card.Description>
        </Card.Copy>
        <Card.Action>
          <ButtonText iconEnd={ChevronRightIcon}>{actionText}</ButtonText>
        </Card.Action>
      </Card.Body>
    </CardBase>
  )
}

export default LessonCard
